<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
export interface PagebuilderYoutubeProps {
    data: {
        gallery_subtitle: string
        gallery_title: string
        gallery: {
            gallery_alt: string
            gallery_title: string
            gallery_image: any
        }[]
    }
}
const props = defineProps<PagebuilderYoutubeProps>()
const data = computed<Gallery>(() => {
    return {
        title: props.data.gallery_title,
        subtitle: props.data.gallery_subtitle,
        data: props.data.gallery.map((image): GalleryItem => {
            return {
                title: image.gallery_title,
                file: {
                    path: image.gallery_image,
                },
                alt: '',
            }
        }),
    }
})
</script>
<template>
  <Gallery
    v-if="data.data[0]?.file?.path"
    :thumbnail="data.data[0].file.path"
    :extra="data.data[0]?.title"
    :data="data"
    heading-level="h2"
  />
</template>
